import React, { useState, useEffect } from 'react';

import Spinner from '@salesforce/design-system-react/components/spinner';
import {
  FactoryEmaillabApiV1Project,
  useProjectServiceDeleteProjectMutation,
  useProjectServiceListProjectsQuery
} from '../../app/apiGenerated';
import Illustration from '@salesforce/design-system-react/components/illustration';
import ProjectsList from './ProjectsList';
import { useNavigate } from 'react-router-dom';

interface Props {
  filter?: string;
}
const ProjectsDatatable = ({ filter }: Props) => {
  const navigate = useNavigate();
  const {
    data: projectsRes,
    isFetching,
    isLoading,
    isSuccess,
    isError,
    isUninitialized
  } = useProjectServiceListProjectsQuery(
    { filter: filter },
    {
      // pollingInterval: 3000,
      // refetchOnMountOrArgChange: true,
      skip: false
    }
  );

  const projects = projectsRes?.projects;
  return (
    <>
      {isLoading || isFetching ? (
        <div
          style={{
            position: 'relative',
            height: '100%',
            width: '100%',
            borderLeft: '1px solid rgb(224, 229, 238)'
          }}
        >
          <Spinner
            size="medium"
            variant="brand"
            assistiveText={{ label: 'Main Frame Loading...' }}
          />
        </div>
      ) : (
        <>
          {projects === undefined ||
          (projects !== undefined && projects.length == 0) ? (
            <Illustration
              heading="It looks like there is no data yet"
              messageBody="Let's get started by creating a new entry and building the list together."
              name="No Access"
              // path="/assets/images/illustrations/empty-state-no-results.svg#no-results"
              path="/assets/images/illustrations/no-data.svg#no-data"
              size="small"
              internalIllustration={true} // silenceDeprecationWarning
              className="height-100 slds-grid slds-grid_vertical slds-grid slds-grid_align-center slds-grid_vertical-align-center width-100"
            />
          ) : projects !== undefined && projects.length > 0 ? (
            <div
              className="slds-grid  overflow-hidden flex-grow-1"
              style={{ maxHeight: '100%' }}
            >
              <ProjectsList
                projects={projects}
                onClick={(p) => navigate('/projects/' + p?.name)}
              />
            </div>
          ) : null}
        </>
      )}
    </>
  );
};

export default ProjectsDatatable;
